import TarotCard from "../../components/TarotCard";
import { ElementTransformation } from "../TransformationMatrix";
import Inertia from "../animations/Inertia";
import { ThrottledAnimation } from "../animations/ThrottledAnimation";
import { RouletteSlot } from "./RouletteSlot";
import { TouchManager, TouchManagerEvent } from "./TouchManager";

type MoveEvent = MouseEvent | TouchManagerEvent;
export default class Roulette {
  private container: HTMLElement;
  private slotCount: number;

  private touchManager: TouchManager;
  private actualRotation = 0;
  private initialRotation = 0;
  private animationStart = 0;
  private throttledAnimation: ThrottledAnimation;
  private inertiaAnimation: Inertia;


  private disabled: boolean = false;

  constructor(slotCount: number) {
    this.container = document.createElement("div");
    this.container.classList.add("roulette");
    this.container.setAttribute("draggable", "false");
    this.slotCount = slotCount;

    this.touchManager = new TouchManager();
    this.throttledAnimation = new ThrottledAnimation();

    this.setupEventListeners();
  }

  public add(card: TarotCard, slot: number): void {
    const rouletteSlot = new RouletteSlot((slot * 360) / this.slotCount);
    card.appendTo(rouletteSlot);
    rouletteSlot.appendTo(this.container);
  }

  public appendTo(parent: HTMLElement): void {
    parent.appendChild(this.container);
  }

  public disable(): void {
    this.disabled = true;
  }

  public enable(): void {
    this.disabled = false;
  }

  private setupEventListeners(): void {
    this.container.addEventListener("mousedown", (event) => {
      event.preventDefault();
      this.activateRotation(event);
    });

    this.container.addEventListener("touchstart", (event) => {
      this.touchManager.start(event);
      this.activateRotation(event);
      console.log("touchstart");
    });

    window.addEventListener("mousemove", this.rotate.bind(this));
    window.addEventListener("touchmove", (event) => {
      const parsedEvent = this.touchManager.move(event);
      this.rotate(parsedEvent);
    });

    ["mouseup", "touchend"].forEach((eventName) => {
      window.addEventListener(eventName, (event) => {
        this.disableRotation(event);
      });
    });
  }

  private activateRotation(event: Event): void {
    if (this.disabled) return;
    
    if (this.inertiaAnimation) {
      this.inertiaAnimation.stop();
      this.actualRotation = this.getActualRotation();
    }

    this.initialRotation = this.actualRotation;
    this.animationStart = window.performance.now();
    this.throttledAnimation.start();
  }

  private disableRotation(event: Event): void {
    if (!this.throttledAnimation.playing) return;

    this.throttledAnimation.stop();
    const speed = this.getSpeed();

    this.inertiaAnimation = new Inertia(this.container, {
      startAngle: this.actualRotation,
      speed: speed,
      transform: "translate(-50%, 0)",
      snapTo: this.snapTo.bind(this),
    });
  }

  private rotate(event: MoveEvent): void {
    if (this.disabled) return;
    
    this.throttledAnimation.nextFrame(() => {
      this.actualRotation += event.movementX * 0.125;
      this.container.style.transform = `translate(-50%, 0) rotateZ(${this.actualRotation}deg)`;
    });
  }

  private getActualRotation(): number {
    const transformation = new ElementTransformation(this.container);
    return transformation.zRotation;
  }
  

  private getSpeed(): number {
    const distance = this.actualRotation - this.initialRotation;

    // Duracion del movimiento en segundos
    const deltaTime = (window.performance.now() - this.animationStart) / 1000;

    return  Math.abs(distance) > 10 ? distance / deltaTime
                                    : Math.sign(distance) * 7.81;
  };

  private snapTo(angle: number): number {
    const slotAngle = 360 / this.slotCount;
    const slot = Math.round(angle / slotAngle);
    const targetAngle = slot * slotAngle;
    return targetAngle;
  }
}
